import React from 'react';
import { CmsAsset } from '../../integrations/contentful/types';
import H from '../elements/H';
import { baseXUnit, imageHoverOpacity } from '../../styles/theme';
import Spacing from '../common/Spacing';
import RouteLink from '../navigation/RouteLink';
import { Paths } from '../../urls/Paths';
import CmsMediaFixedHeight from '../cms/CmsMediaFixedHeight';
import HyperLink from '../elements/HyperLink';

interface CountryCardProps {
  mainImage?: CmsAsset;
  name: string;
  slug: string;
}

const CountryCard: React.FunctionComponent<CountryCardProps> = ({
  mainImage,
  name,
  slug
}) => {
  return (
    <div className="country-card" data-cy="country-card">
      <RouteLink
        path={Paths.Country}
        params={{
          slug: slug
        }}
      >
        <HyperLink noLinkStateStyles data-testid="country-link">
          <Spacing bottom={1}>
            <CmsMediaFixedHeight
              media={mainImage}
              fixedHeight={18}
              borderRadius={1}
            />
          </Spacing>
          <Spacing bottom={2}>
            <H tag="h3" styling="h3">
              <strong>{name}</strong>
            </H>
          </Spacing>
        </HyperLink>
      </RouteLink>
      {/*language=CSS*/}
      <style jsx>{`
        .country-card {
          padding-bottom: ${baseXUnit(2)};
        }
        .country-card:hover :global(img) {
          opacity: ${imageHoverOpacity};
        }
      `}</style>
    </div>
  );
};

export default CountryCard;
